/**
 * Refetch Data Actor
 *
 * XState actor that fetches fresh data after a process completes.
 * Similar to fetchInitialData but simpler (no status check needed).
 */
import { fromPromise } from 'xstate'
import { fetchImportPreviewData } from 'services/importengine'
import { ImportData, ImportDataRowsFormat } from '../../importer-types'

export interface RefetchDataInput {
  importNumber: number
}

export interface RefetchDataOutput {
  data: ImportData | null
  skipMatching: boolean
}

/**
 * Convert ImportDataRowsFormat (from API) to ImportData (for UI)
 */
function fromRowsJSON(data: ImportDataRowsFormat): ImportData {
  return {
    headers: data.headers.map((h) => ({
      original: h.original,
      mapped: h.mapped,
    })),
    rows:
      data.rows?.rows?.map(
        (row) =>
          Object.fromEntries(
            (data.rows?.columns || []).map((key, i) => [key, row[i]])
          ) as ImportData['rows'][number]
      ) || [],
  }
}

export const refetchDataActor = fromPromise<
  RefetchDataOutput,
  RefetchDataInput
>(async ({ input }) => {
  const response = await fetchImportPreviewData(input.importNumber)
  return {
    data: response.data ? fromRowsJSON(response.data) : null,
    skipMatching: response.skip_matching ?? false,
  }
})
